import sale from '@/api/sale/sale-area'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  sales: [],
  provinces: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_SALE(state, value) {
    state.sales = value
  },
  SET_PROVINCES(state, value) {
    state.provinces = value
  },
  CLEAR_STATE(state) {
    state.sales = []
    state.provinces = []
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return sale.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return sale.store(data)
  },
  update(context, { id, data }) {
    return sale.update(id, data)
  },
  destroy(context, id) {
    return sale.destroy(id)
  },
  async fetchResources(context) {
    if (!context.state.provinces.length > 0) {
      let province_response = await sale.province()
      context.commit('SET_PROVINCES', province_response.data)
    }
    let sale_response = await sale.sale()
    context.commit('SET_SALE', sale_response.data)
  },
  getDistrict(context, query) {
    if (!query) return
    return sale.district({ params: query })
  },
  getCommune(context, query) {
    if (!query) return
    return sale.commune({ params: query })
  }
}
